import React from "react";
import { Box, useTheme } from "@mui/material";

const PremiumBadge: React.FC<{ label: string }> = ({ label }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        padding: "4px 10px",
        borderRadius: "8px",
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        fontSize: "12px",
        fontWeight: 700,
        lineHeight: 1.2,
        flexShrink: 0,
      }}
    >
      {label}
    </Box>
  );
};

export default PremiumBadge;
